import Toastr from "../util/Toastr";

export default class ForecastOpmCtrl {
  constructor(ForecastOpmService) {
    this.ForecastOpmService = ForecastOpmService;

    this.language = 'CS';
    this.file = null;
    this.errors = [];
    this.warnings = [];
    this.messages = [];
  }

  onFile($file) {
    this.file = $file;
  }

  export() {
    this.ForecastOpmService.export(this.language);
  }

  import() {
    this.errors = [];
    this.warnings = [];
    this.messages = [];

    Toastr.progress();

    const self = this;
    this.ForecastOpmService.import(this.file)
      .then(function (resp) {
        Toastr.clear();

        self.errors = resp.errors;
        self.warnings = resp.warnings;
        self.messages = resp.messages;
      });
  }
}



// WEBPACK FOOTER //
// ./src/ForecastOpm/ForecastOpmCtrl.js